// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';
import { selectStepsProgresses } from '../../feature';

// Models
import { BiddingStepProgress } from '@/models/propertyProgress.model';
import { StepType } from '@/models/step.model';

// Components
import { ResetStepButton, StepCard, StyledRow, StyledText } from '../../components';

// Helpers
import { finalStatuses, getAuctionUrl } from '../../helpers';

type TBiddingProgressContainerProps = {
  hideResetButton?: boolean;
};

const BiddingProgressContainer = ({ hideResetButton = false }: TBiddingProgressContainerProps) => {
  const { t } = useTranslation('property');
  const stepsProgresses = useAppState(selectStepsProgresses);
  const viewingProgress = stepsProgresses?.[StepType.BIDDING] as BiddingStepProgress;

  const auctionUrl = getAuctionUrl(viewingProgress?.property_id);

  if (!viewingProgress) return null;

  return (
    <StepCard title={t('step_bidding')} status={viewingProgress.status}>
      {!!auctionUrl && (
        <StyledRow>
          <StyledText>
            {t('bidding_auction_link')}
            <a href={auctionUrl} target={'_blank'} rel="noreferrer">
              {auctionUrl}
            </a>
          </StyledText>
        </StyledRow>
      )}
      <StyledRow>
        {!hideResetButton && finalStatuses.includes(viewingProgress.status) && (
          <ResetStepButton
            propertyId={viewingProgress?.property_id}
            stepName={StepType.BIDDING}
            shouldResetStepData={false}
          />
        )}
      </StyledRow>
    </StepCard>
  );
};

export default BiddingProgressContainer;
